import React from 'react';
import { Form, Message } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
// import _find from 'lodash/find';

import EstaSegGral from '../../../components/funcionales/estaseggral';

//utils
import queries from '../../../utils/queries';

import general from '../../../modulos/general';

function getNumDiasMes(mesDias, agnoDias){
  /*
      Los meses 1,3,5,7,8,10,12 siempre tienen 31 días
      Los meses 4,6,9,11 siempre tienen 30 días
      El mes de febrero dependiendo del año puede tener 28 o 29 días
  */
  let mes = parseInt(mesDias, 10)
  let agno = parseInt(agnoDias, 10)

  if( (mes === 1) || (mes === 3) || (mes === 5) || (mes === 7) || (mes === 8) || (mes === 10) || (mes === 12) ) 
    return 31;
  else if( (mes === 4) || (mes === 6) || (mes === 9) || (mes === 11) ) 
    return 30;
  else if( mes === 2 )
  {
      if((agno % 4 === 0) && ((agno % 100 !== 0) || (agno % 400 === 0)))
        return 29;
      else
        return 28;
  }   
}

const styles1 ={
  paraH1:{
      padding: '0em',
      margin: '0em',
      color: '#302b63',
  },
  paraH2_01:{
    padding: '0em',
    margin: '0em',
    color: '#2C7744',
  },
  paraH2_02:{
      padding: '0em',
      margin: '0em',
      color: 'red',
  },
  colorRed:{
      color: 'red',
  },
  colorBlue:{
      color: '#302b63',
  },
  styPaddMarg:{
      padding: '0.2em 0.1em 0.2em 0.1em',
      fontSize: '0.9em'
  },
  styInput:{
    width: '4em',
  },
}

// const ServOf = ({styles, elemento}) => {
//   return(
//     <tr className=''>
//       <td className=''>{elemento.descrClaseServ}</td>
//       <td className=''>{elemento.nombreResumido}</td>
//       <td className=''>{elemento.descripcionServicio}</td>
//       <td className=''>{elemento.porcDctoOferta}</td>
//     </tr>
//   )
// };

// const ListaServOf = ({styles, list}) => {
//   const nivel1Detalle = list.map((elemento, _id) => <ServOf styles={styles} elemento={elemento} key={elemento._id}/>);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

// //dropdown OFERTAS
// const DetalleSelOf = props => {
//     return (
//       <option dato1={props.elemento._id} value={props.elemento.codigoOferta}>{props.elemento.codigoOferta} ={">"} {props.elemento.descrOferta}</option>
//     )
//   };
  
//   const ListaOf = ({styles, handleOfNva, list}) => {
//     let detalleOf = list.map((elemento, _id) => <DetalleSelOf elemento={elemento} key={elemento._id}/>);
//     return(
//       <div>
//         <select style={styles.input}className="ui simple selection dropdown fluid" name="oferta" id="miListaOf" onChange={(ev) => handleOfNva(ev, list)}>
//           <option value="">Seleccionar oferta ...</option>
//           {detalleOf}
//         </select>
//       </div>
//     )
//   };
//   //Fin dropdown OFERTAS

//dropdown OFICINAS
const DetalleOf1 = props => {
  return (
    <option style={props.styles.input}>{props.elemento.descrOficina}</option>
  )
};

const ListaOf = ({styles, list, handleChangeOf}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleOf1 styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="oficina" id="miListaOf" onChange={(ev)=>handleChangeOf(ev)}>
        <option value="">Seleccionar...</option>
        {Nivel1Detalle}
      </select>
    </div>
  )
};
//Fin dropdown OFICINAS

//dropdown RANGOS FACT
const DetalleRango = props => {
  return (
    <option dato1={props.elemento._id} dato2={props.elemento.prefijo} value={props.elemento.proxFact}>{props.elemento.prefijo} {props.elemento.factInicial} - {props.elemento.factFinal}</option>
    // <option dato1={props.elemento._id} value={props.elemento.proxFact}>{props.elemento.factInicial} - {props.elemento.factFinal}</option>
  )
};

const ListaRango = ({styles, handleChange, list}) => {
  let detalleR = list.map((elemento, _id) => <DetalleRango elemento={elemento} key={elemento._id}/>);
  let selecc = false
  if(list.length>1){
    selecc = true
  }
  return(
    <div>
      <select style={styles.input}className="ui simple selection dropdown fluid" name="rango" id="miListaR" onChange={(ev) => handleChange(ev, list)}>
        {selecc &&
        <option value="">Seleccionar rango ...</option>
        }
        {detalleR}
      </select>
    </div>
  )
};
//Fin dropdown RANGOS FACT

class RecPagoAdel2 extends React.Component {
  state={
    argsDocumCli: {contrato: this.props.idLista.contrato,
                nombreCliente: this.props.idLista.nombreCliente,
                apellidoCliente: this.props.idLista.apellidoCliente,
                telefono1: !this.props.idLista.telefono1?'':this.props.idLista.telefono1,
                telefono2: !this.props.idLista.telefono2?'':this.props.idLista.telefono2,
                telefono3: !this.props.idLista.telefono3?'':this.props.idLista.telefono3,
                observaciones: !this.props.idLista.observaciones?'':this.props.idLista.observaciones,
                _id: this.props.idLista._id},
                argsAdd: {descrOficina: this.props.descrOficina, valorEf: 0, valorCh: 0, valorTr: 0, valorTC: 0, valorTD: 0},
                listaR: [],
    stListServTarAct: this.props.idLista.tarifa?this.props.idLista.tarifa:{},
    stListServOfAct: this.props.idLista.oferta?this.props.idLista.oferta:{},
    listServOfSel: [], ofertaSel: "", numMesesAd: 0, fechaFinOferta: "", fechaInicioOferta: "",
    confirmaAct: false, open: false
  }

  handleChange = (ev)=>{
    // console.log(ev.target.value)
    // console.log(ev.target.name)
    const argsAdd = this.state.argsAdd
    if(ev.target.name==="rango"){
      var miLista = document.getElementById("miListaR");
      argsAdd['_idRango'] = miLista.options[miLista.selectedIndex].attributes[0].value
      argsAdd['prefijoFact'] = miLista.options[miLista.selectedIndex].attributes[1].value
    }else{
      argsAdd[ev.target.name] = ev.target.value
      argsAdd['contrato'] = this.props.idLista.contrato
    }
    this.setState({argsAdd, confirmaAct: false});
  }

  handleChangeColecc = (ev, elemento) => {
    if(ev.target.name === "numMeses"){
      this.setState({numMesesAd: ev.target.value, confirmaAct: false});

      if(this.state.ofertaSel){
        let fechaFinal = new Date(), fechaInicio = new Date()
        fechaInicio.setDate(fechaInicio.getUTCDate())
        fechaInicio = (fechaInicio.getFullYear()) + '-' + ((fechaInicio.getMonth()+1)<10?'0'+(fechaInicio.getMonth()+1):(fechaInicio.getMonth()+1)) + '-01'

        fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(ev.target.value * 30, 10))
        fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
        const numDM = getNumDiasMes(fechaFinal.substr(5, 2), fechaFinal.substr(0, 4))
        fechaFinal = fechaFinal.substr(0, 8) + numDM
        this.setState({fechaFinOferta: fechaFinal});
        this.setState({fechaInicioOferta: fechaInicio});
      }else{
        this.setState({fechaFinOferta: ""})
        this.setState({fechaInicioOferta: ""})
      }
    }

    if(ev.target.name === "fechaFinOferta"){
      this.setState({fechaFinOferta: ev.target.value});
    }
    if(ev.target.name === "fechaInicioOferta"){
      this.setState({fechaInicioOferta: ev.target.value});
    }
  }

  handleChangeOf = (ev) => {
    if(ev.target.name === "oficina"){
      const argsAdd = this.state.argsAdd
      let miLista = document.getElementById("miListaOf");
      argsAdd['descrOficina'] = miLista.options[miLista.selectedIndex].text  
      this.setState({argsAdd, confirmaAct: false});
    }
  }

  handleOfNva = (ev, list) => {
    let elemento2 = list.filter(elemento => elemento.codigoOferta===ev.target.value)
    let listServOfSel = []
    let ofertaSel = ""
    const listServTarAct = this.state.stListServTarAct

    if(listServTarAct.codigoTarifa){
      elemento2.forEach((elemento3, ii) => {
        elemento3.servicios.forEach((elemento, i) => {
          ofertaSel = `${elemento3.codigoOferta} => ${elemento3.descrOferta}`
          if(elemento.codigoServicio){
            const indexSearch = listServTarAct.servicios.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
  //Se tienen en cuenta solo los servicios de la oferta que esten en la tarifa
            if(indexSearch!==-1){
              listServOfSel.push({codigoOferta: elemento3.codigoOferta, descrOferta: elemento3.descrOferta,
                codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido, descripcionServicio: elemento.descripcionServicio,
                _idSubclaseServ: elemento.subclaseserv._id, codigoSubclaseServ: elemento.subclaseserv.codigoSubclaseServ,
                descrSubclaseServ: elemento.subclaseserv.descrSubclaseServ, _idClaseServ: elemento.subclaseserv.claseserv._id,
                codigoClaseServ: elemento.subclaseserv.claseserv.codigoClaseServ, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
                porcDctoOferta: elemento.porcDctoOferta, numDiasOferta: elemento.numDiasOferta,
                _id: i
              });
            }
          }
        })
      })
    }
    if(elemento2.length===0||this.state.numMesesAd===0){
      this.setState({fechaFinOferta: ""})
      this.setState({fechaInicioOferta: ""})
    }else{
      let fechaFinal = new Date(), fechaInicio = new Date()
      fechaInicio.setDate(fechaInicio.getUTCDate())
      fechaInicio = (fechaInicio.getFullYear()) + '-' + ((fechaInicio.getMonth()+1)<10?'0'+(fechaInicio.getMonth()+1):(fechaInicio.getMonth()+1)) + '-01'

      fechaFinal.setDate(fechaFinal.getUTCDate() + parseInt(this.state.numMesesAd * 30, 10))
      fechaFinal = (fechaFinal.getFullYear()) + '-' + ((fechaFinal.getMonth()+1)<10?'0'+(fechaFinal.getMonth()+1):(fechaFinal.getMonth()+1)) + '-' + (fechaFinal.getUTCDate()<10?'0'+fechaFinal.getUTCDate():fechaFinal.getUTCDate())
      const numDM = getNumDiasMes(fechaFinal.substr(5, 2), fechaFinal.substr(0, 4))
      fechaFinal = fechaFinal.substr(0, 8) + numDM
      this.setState({fechaFinOferta: fechaFinal});
      this.setState({fechaInicioOferta: fechaInicio});
    }

    this.setState({listServOfSel})
    this.setState({ofertaSel, confirmaAct: false})
  }
  
  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  componentDidUpdate(prevProps){
    if(this.props.allRangoFact.allRangoFact){
      if(this.state.listaR.length===0&&this.props.allRangoFact.allRangoFact.length>0){
        let listaR = this.props.allRangoFact.allRangoFact.filter(elemento => elemento.estadoRangoFact===true)
        this.setState({listaR})
      }
    
      // console.log(this.state.argsAdd)
      // console.log(this.state.listaR)
      if(!this.state.argsAdd._idRango&&this.state.listaR.length===1&&this.state.listaR.length>0){
        const argsAdd = this.state.argsAdd
        argsAdd['_idRango'] = this.state.listaR[0]._id
        argsAdd['prefijoFact'] = this.state.listaR[0].prefijo
        // argsAdd['prefijoFact'] = this.props.prefijoFact
        this.setState({argsAdd});
      }
    }
  }

render(){
  const {argsDocumCli, argsAdd, listaR, stListServTarAct, listServOfSel, ofertaSel, numMesesAd,
    fechaFinOferta, fechaInicioOferta, confirmaAct, open} = this.state;
// console.log(this.state.argsDocumCli)
// console.log(this.props.idLista)
// console.log(this.props.list4)

let estadoCliente = this.props.idLista.estadoCliente
let saldoPendiente = this.props.idLista.saldoPendiente

let linea1DNN = ""
let linea2DNN = ""
let linea3DNN = ""
let linea4DNN = ""
let direccion1 = ""
let direccion2 = ""

if(this.props.idLista.direccion.descrTipoVia1){
  linea1DNN = `${this.props.idLista.direccion.descrTipoVia1?this.props.idLista.direccion.descrTipoVia1:""}
    ${this.props.idLista.direccion.numeroTipoVia1?this.props.idLista.direccion.numeroTipoVia1:""}
    ${this.props.idLista.direccion.descrTipoVia2?this.props.idLista.direccion.descrTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2?this.props.idLista.direccion.numeroTipoVia2:""}
    ${this.props.idLista.direccion.numeroTipoVia2F?this.props.idLista.direccion.numeroTipoVia2F:""}
    ${this.props.idLista.direccion.descrTipoUnd1?this.props.idLista.direccion.descrTipoUnd1:""}
    ${this.props.idLista.direccion.numeroTipoUnd1?this.props.idLista.direccion.numeroTipoUnd1:""}
    ${this.props.idLista.direccion.descrTipoUnd2?this.props.idLista.direccion.descrTipoUnd2:""}
    ${this.props.idLista.direccion.numeroTipoUnd2?this.props.idLista.direccion.numeroTipoUnd2:""}`

    linea2DNN = `${this.props.idLista.direccion.descrTiUndMat?this.props.idLista.direccion.descrTiUndMat:""}
    ${this.props.idLista.direccion.descrUndMat?this.props.idLista.direccion.descrUndMat:""}`

    linea3DNN = `${this.props.idLista.dirmayor.descrDpto?this.props.idLista.dirmayor.descrDpto:""}
    ${this.props.idLista.dirmayor.ciudades.nombreCiudad?", " + this.props.idLista.dirmayor.ciudades.nombreCiudad:""}`

    linea4DNN = `${this.props.idLista.dirmayor.ciudades.zonas.nombreZona?", Zona: " + this.props.idLista.dirmayor.ciudades.zonas.nombreZona:""}
    ${this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio?", Barrio: " + this.props.idLista.dirmayor.ciudades.zonas.barrios.nombreBarrio:""}`

    direccion1 = linea1DNN + ' ' + linea2DNN
    direccion2 = linea3DNN + ' ' + linea4DNN
  }

  let totRecibido = 0
  if(argsAdd.valorEf) {
    totRecibido += parseInt(argsAdd.valorEf, 10)
  }
  if(argsAdd.valorCh) {
    totRecibido += parseInt(argsAdd.valorCh, 10)
  }
  if(argsAdd.valorTr) {
    totRecibido += parseInt(argsAdd.valorTr, 10)
  }
  if(argsAdd.valorTC) {
    totRecibido += parseInt(argsAdd.valorTC, 10)
  }
  if(argsAdd.valorTD) {
    totRecibido += parseInt(argsAdd.valorTD, 10)
  }

  // let lista9 = []
  // if(this.props.allOferta.allOferta){
  //   lista9 = this.props.allOferta.allOferta
  //   lista9 = lista9.filter(elemento => elemento.estadoOferta===true)
  // }

  let tarifaAct = ""
  let rentaAct = 0
  let tarifaConOfSel = 0
  let listServTar = []
  // console.log(stListServTarAct)
  if(stListServTarAct.codigoTarifa){
    const elemento3 = stListServTarAct
    elemento3.servicios.forEach((elemento, i) => {
      if(elemento.estadoServicio==="A"){
      const indexSearch = listServOfSel.findIndex( servicio => servicio.codigoServicio === elemento.codigoServicio );
      let valorServPA = 0
      let valorServAI = 0
      let imptos = []
      if(indexSearch!==-1){
        let valorServ = elemento.valorServicios - (elemento.valorServicios * listServOfSel[indexSearch].porcDctoOferta / 100)
        let valorImpto = 0
        let totImpto = 0
        elemento.imptos.forEach((elemento1, _id) => {
          valorImpto = Math.round((valorServ-(valorServ / (1 + (elemento1.porcImpto / 100)))) * numMesesAd)
          totImpto += valorImpto
          imptos.push({codigoImpto: elemento1.codigoImpto,
            descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
            valorImpto: valorImpto})
        })
        valorServPA = valorServ * numMesesAd
        tarifaConOfSel += valorServ
        valorServAI = valorServPA - totImpto
      }else{
        valorServPA = elemento.valorServicios * numMesesAd
        let valorImpto = 0
        let totImpto = 0
        elemento.imptos.forEach((elemento1, _id) => {
          valorImpto = Math.round((elemento.valorServicios-(elemento.valorServicios / (1 + (elemento1.porcImpto / 100)))) * numMesesAd)
          totImpto += valorImpto
          imptos.push({codigoImpto: elemento1.codigoImpto,
            descrImpto: elemento1.descrImpto, porcImpto: elemento1.porcImpto,
            valorImpto: valorImpto})
        })
        tarifaConOfSel += elemento.valorServicios
        valorServAI = valorServPA - totImpto
      }
      valorServPA = Math.round(valorServPA)
      rentaAct += elemento.valorServicios

      let servicioFra = this.props.allServicios.allServicios.filter(servicio => servicio.codigoServicio === elemento.codigoServicio)
      // let conceptoEnFra = ""
      let consecEnFra = -1
      if(servicioFra.length>0){
        // conceptoEnFra = servicioFra[0].conceptoEnFra
        consecEnFra = servicioFra[0].consecEnFra
      }

      listServTar.push({contrato: this.props.idLista.contrato,
        codigoServicio: elemento.codigoServicio, nombreResumido: elemento.nombreResumido,
        descripcionServicio: elemento.descripcionServicio, descrClaseServ: elemento.subclaseserv.claseserv.descrClaseServ,
        concepto: `Pago adelantado ${numMesesAd} meses`, periodo: `${numMesesAd} meses`, consecEnFra,
        valorAntesImptos: valorServAI, imptos: imptos,
        valorTotal: valorServPA, valorDetalle: valorServPA,
      });
      // console.log(listServTar)
    }
    })
    tarifaAct = `${elemento3.codigoTarifa} => ${elemento3.descrTarifa} => Renta mensual servicios activos: $${rentaAct}`
  }
  tarifaConOfSel = tarifaConOfSel *  numMesesAd
  tarifaConOfSel = Math.round(tarifaConOfSel)
  let totAPagar = Math.round(tarifaConOfSel)
  // let ofertaAct = ""
  // if(stListServOfAct.codigoOferta){
  //   ofertaAct = `${stListServOfAct.codigoOferta} => ${stListServOfAct.descrOferta}`
  // }
  let conceptoPA = `${numMesesAd} meses`
  let ofertaPA = `Pago adelantado ${ofertaSel}`

  let fechaIni = new Date(fechaInicioOferta).getTime();
  let fechaFin = new Date(fechaFinOferta).getTime();
  let numdiApliOf = Math.round((fechaFin - fechaIni) / (1000*60*60*24))
  // console.log(numdiApliOf)
  if(listServOfSel.length>0&&numMesesAd>0){
    listServOfSel.forEach((elemento, i) => {
      listServOfSel[i].fechaInicioOferta = fechaInicioOferta
      listServOfSel[i].fechaFinOferta = fechaFinOferta
      listServOfSel[i].numDiasOferta = numdiApliOf
    })
  }
// console.log(listServTar)
// console.log(stListServTarAct)
// console.log(this.props.prefijoFact)
  return(
    <div>
      <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
        <i className="large hand point down yellow icon"></i>
        Cliente
      </button>
      <div>

      <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
        <div>
          <h1 style={styles1.paraH1}>
            {argsDocumCli.contrato} - {argsDocumCli.nombreCliente} {argsDocumCli.apellidoCliente} - &nbsp;&nbsp;
            <span style={estadoCliente!=='ACTIVO'?styles1.paraH2_02:styles1.paraH2_01}>
              {estadoCliente}
            </span>
          </h1>
          <div className="ui two column stackable grid">
            <div className="row container">
              <div className="column" style={{width: '65%'}}>
                <p style={{color: '#302b63', fontStyle: 'italic', paddingTop: '0.7em'}}>
                  {direccion1}<br/>
                  {direccion2}
                </p>
              </div>
              <div className="column" style={{width: '35%'}}>
                <p>
                  <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                    Saldo: &nbsp;&nbsp;
                    <span style={{color: '#302b63', fontSize: '2em'}}> ${general.formatNum(saldoPendiente.toString())}</span>
                  </span>
                </p>
              </div>
            </div>
          </div>

          {(saldoPendiente>0||estadoCliente!=='ACTIVO'||tarifaAct === "") &&
            <div>
              <hr></hr>
              <div className="ui one column stackable grid">
                <div className="row container">
                    <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                    &nbsp;&nbsp;&nbsp;&nbsp;El cliente debe estar ACTIVO, tener tarifa y saldo pendiente menor o igual a cero
                    </p>
                </div>
              </div>
              <hr></hr>
            </div>
          }

          {(saldoPendiente<=0&&estadoCliente==='ACTIVO'&&tarifaAct !== "") &&
            // <Form onSubmit={(ev)=>{
            //   this.props.handleSubmit(ev, argsAdd, totRecibido, totAPagar, conceptoPA, ofertaPA, saldoPendiente, listServOfSel)}
            //   // this.props.handleClickRegrRecPago(ev)}
            // }>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsAdd, listServTar, totRecibido, totAPagar, conceptoPA, ofertaPA, saldoPendiente, listServOfSel, listaR, this.props.empresa):()=>{}}>
              <div>
                <hr></hr>
                <div className="ui three column stackable grid">
                  <div className="row container">
                    <div className="column" style={{width: '22%'}}>
                      <p style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                        Recibir pago adelantado
                      </p>
                    </div>
                    <div className="column" style={{width: '53%'}}>
                      <p>
                        <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                          Total recibido: &nbsp;&nbsp;
                          <span style={{color: '#302b63', fontSize: '2em'}}> ${totRecibido}</span>
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span style={{background: '#7F7FD5', color: 'white', fontSize: '1.2em'}} className='ui basic label'>
                          Total a pagar: &nbsp;&nbsp;
                          <span style={{color: '#302b63', fontSize: '2em'}}> ${totAPagar}</span>
                        </span>
                      </p>
                    </div>
                    {(!this.props.descrOficina||this.props.descrOficina==="Todas...") &&
                      <div className="column" style={{width: '23%'}}>
                        <label style={{color: '#302b63', fontSize: '1.5em', fontWeight: 'bold'}}>Oficina</label>
                        <Form.Field>
                          <ListaOf styles={this.props.styles} list={this.props.listaOf} handleChangeOf={this.handleChangeOf}/>
                        </Form.Field>
                      </div>
                    }
                  </div>
                </div>
                <hr></hr>
                <div>
                  <div className='ui blue inverted raised segment'>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Tarifa: &nbsp;&nbsp;
                      <span style={{color: '#302b63', fontSize: '0.9em', fontWeight: 'normal', margin: '0em'}}>
                        {tarifaAct}
                      </span>
                    </p>
                    {/* <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Oferta actual: &nbsp;&nbsp;
                      <span style={{color: '#302b63', fontSize: '0.9em', fontWeight: 'normal', margin: '0em'}}>
                        {ofertaAct}
                      </span>
                    </p> */}

                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.4em 0em 0em 0em'}}>
                      Renta mensual servicios activos: &nbsp;&nbsp;
                      <span style={{color: 'red', fontSize: '0.9em', fontWeight: 'bold', margin: '0em'}}>
                        ${tarifaConOfSel}
                      </span>
                    </p>
                    <Form.Field>
                      <div className="ui two column stackable grid">
                        <div className="column" style={{width: '15%'}}>
                          <label style={this.props.styles.label}># de meses</label>
                          <input type='number' step="1" min="0" autoFocus style={this.props.styles.input} autoComplete="off" name="numMeses" id="numMeses" placeholder='# de meses' onChange={this.handleChangeColecc}/>
                        </div>

                        {listaR.length>1 &&
                          <div className="column" style={{width: '35%'}}>
                            <label style={this.props.styles.label}>Rangos de facturación</label>
                            <ListaRango list={listaR} styles={this.props.styles} handleChange={this.handleChange}/>
                          </div>
                        }
                      </div>
                    </Form.Field>

                    {/* <Form.Field>
                          <div className="ui two column stackable grid">
                            <div className="column" style={{width: '50%'}}>
                              <label style={this.props.styles.label}>Oferta</label>
                              <ListaOf list={lista9} styles={this.props.styles} handleOfNva={this.handleOfNva}/>
                            </div>

                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Inicia</label>
                              <input style={this.props.styles.input} type='date' name="fechaInicioOferta" id="fechaInicioOferta" value={fechaInicioOferta} onChange={this.handleChangeColecc}/>
                            </div>

                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Finaliza</label>
                              <input style={this.props.styles.input} type='date' name="fechaFinOferta" id="fechaFinOferta" value={fechaFinOferta} onChange={this.handleChangeColecc}/>
                            </div>
                          </div>
                        </Form.Field> */}

                    {/* <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                      <thead className=''>
                        <tr className=''>
                          <th className=''>Clase</th>
                          <th className=''>Servicio</th>
                          <th className=''>Descripción servicio</th>
                          <th className=''>% Dcto</th>
                        </tr>
                      </thead>
                      <ListaServOf styles={this.props.styles} list={listServOfSel}/>
                    </table> */}
                  </div>
                </div>

                <div className='ui blue inverted raised segment'>
                  <div className="ui one column stackable grid">
                    <div className="row container">
                      <div className="column" width="100%">
                        <Form.Field>
                          <div className="column" style={{width: '23%'}}>
                            <label style={this.props.styles.label}>$ Efectivo</label>
                            <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorEf" id="valorEf" placeholder='Efectivo' onChange={this.handleChange}/>
                          </div>
                        </Form.Field>
                        <Form.Field>
                          <div className="ui four column stackable grid">
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>$ Cheque</label>
                              <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorCh" id="valorCh" placeholder='Cheque' onChange={this.handleChange}/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}># cheque</label>
                              <input style={this.props.styles.input} autoComplete="off" name="numeroCh" id="numeroCh" onChange={this.handleChange} placeholder='# cheque'/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Banco</label>
                              <input style={this.props.styles.input} autoComplete="off" name="bancoCh" id="bancoCh" onChange={this.handleChange} placeholder='Banco'/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Fecha vencimiento</label>
                              <input style={this.props.styles.input} type='date' name="fechaVencCh" id="fechaVencCh" onChange={this.handleChange}/>
                            </div>
                          </div>
                        </Form.Field>
                        <Form.Field>
                          <div className="ui four column stackable grid">
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>$ Transferencia</label>
                              <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTr" id="valorTr" placeholder='Transferencia' onChange={this.handleChange}/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Banco</label>
                              <input style={this.props.styles.input} autoComplete="off" name="bancoTr" id="bancoTr" onChange={this.handleChange} placeholder='Banco'/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Fecha transferencia</label>
                              <input style={this.props.styles.input} type='date' name="fechaTr" id="fechaTr" onChange={this.handleChange}/>
                            </div>
                          </div>
                        </Form.Field>
                        <Form.Field>
                          <div className="ui four column stackable grid">
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>$ Tarjeta débito</label>
                              <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTD" id="valorTD" placeholder='Valor' onChange={this.handleChange}/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Banco</label>
                              <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={this.handleChange} placeholder='Banco'/>
                            </div>
                          </div>
                        </Form.Field>
                        <Form.Field>
                          <div className="ui four column stackable grid">
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>$ Tarjeta crédito</label>
                              <input type='number' step="1" min="0" style={this.props.styles.input} autoComplete="off" name="valorTC" id="valorTC" placeholder='Valor' onChange={this.handleChange}/>
                            </div>
                            <div className="column" style={{width: '25%'}}>
                              <label style={this.props.styles.label}>Banco</label>
                              <input style={this.props.styles.input} autoComplete="off" name="bancoTD" id="bancoTD" onChange={this.handleChange} placeholder='Banco'/>
                            </div>
                          </div>
                        </Form.Field>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr></hr>

              <EstaSegGral btnText='Recibir pago' open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>

              {/* <Button style={{color: '#FDC830', background: 'linear-gradient(#000046, #1CB5E0)'}} style={this.props.styles.confirmar} type='submit' fluid>
                  Recibir pago
              </Button> */}
            </Form>
          }
          {
            this.props.errors.length?<Message negative header="Los siguientes errores:"
            list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
          }

          </div>
        </div>
      </div>
    </div>
  )
}
}

export default compose(
  graphql(queries.query.allOferta, {name:'allOferta', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allRangoFact, {name:'allRangoFact', options: (props) => {return {variables: {}}}}),
  graphql(queries.query.allServicios, {name:'allServicios', options: (props) => {return {variables: {}}}}),

    // graphql(queries.mutation.createUsuario, {name:'createUsuario'}),
    // graphql(queries.mutation.createCliente, {name:'createCliente'}),
    // graphql(queries.mutation.editCliente, {name:'editCliente'}),
    // graphql(queries.mutation.createServicio, {name:'createServicio'}),
  )(RecPagoAdel2)